module.exports = __webpack_public_path__ + "static/img/sy-9.4b8d7cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/sy-9.png
// module id = 5gOh
// module chunks = 63